export const candidatelistDetails = [
  {
    Key:"1",
    Cand_ID: "Cand-001",
    Image: "user-01.jpg",
    Candidate: "Harold Gaynor",
    Email: "harold@example.com",
    Applied_Role: "Accountant",
    Phone: "(146) 8964 278",
    Applied_Date: "12/09/2024",
    Status: "Sent",
  },
  {
    Key:"2",
    Cand_ID: "Cand-002",
    Image: "user-34.jpg",
    Candidate: "Sandra Ornellas",
    Email: "sandra@example.com",
    Applied_Role: "App Developer",
    Phone: "(148) 9648 218",
    Applied_Date: "24/10/2024",
    Status: "Scheduled",
  },
  {
    Key:"3",
    Cand_ID: "Cand-003",
    Image: "user-09.jpg",
    Candidate: "John Harris",
    Email: "john@example.com",
    Applied_Role: "Technician",
    Phone: "(196) 2348 947",
    Applied_Date: "18/02/2024",
    Status: "Interviewed",
  },
  {
    Key:"4",
    Cand_ID: "Cand-004",
    Image: "user-26.jpg",
    Candidate: "Carole Langan",
    Email: "carole@example.com",
    Applied_Role: "Web Developer",
    Phone: "(138) 6487 295",
    Applied_Date: "17/10/2024",
    Status: "Offered",
  },
  {
    Key:"5",
    Cand_ID: "Cand-005",
    Image: "user-39.jpg",
    Candidate: "Charles Marks",
    Email: "charles@example.com",
    Applied_Role: "Sales Executive Officer",
    Phone: "(154) 6485 218",
    Applied_Date: "20/07/2024",
    Status: "Hired",
  },
  {
    Key:"6",
    Cand_ID: "Cand-006",
    Image: "user-24.jpg",
    Candidate: "Kerry Drake",
    Email: "kerry@example.com",
    Applied_Role: "Designer",
    Phone: "(185) 5947 097",
    Applied_Date: "20/07/2024",
    Status: "Rejected",
  },
  {
    Key:"7",
    Cand_ID: "Cand-007",
    Image: "user-33.jpg",
    Candidate: "David Carmona",
    Email: "david@example.com",
    Applied_Role: "Account Manager",
    Phone: "(106) 3485 978",
    Applied_Date: "29/08/2024",
    Status: "Hired",
  },
  {
    Key:"8",
    Cand_ID: "Cand-008",
    Image: "user-10.jpg",
    Candidate: "Margaret Soto",
    Email: "margaret@example.com",
    Applied_Role: "SEO Analyst",
    Phone: "(174) 3795 107",
    Applied_Date: "22/02/2024",
    Status: "Scheduled",
  },
  {
    Key:"9",
    Cand_ID: "Cand-009",
    Image: "user-11.jpg",
    Candidate: "Jeffrey Thaler",
    Email: "jeffrey@example.com",
    Applied_Role: "Admin",
    Phone: "(128) 0975 348",
    Applied_Date: "03/11/2024",
    Status: "App Received",
  },
  {
    Key:"10",
    Cand_ID: "Cand-010",
    Image: "user-57.jpg",
    Candidate: "Joyce Golston",
    Email: "joyce@example.com",
    Applied_Role: "Business Analyst",
    Phone: "(132) 1876 304",
    Applied_Date: "17/12/2024",
    Status: "Hired",
  },
];
